(function () {
  'use strict';

  /* ---------- Helpers generales (scoped) ---------- */
  const $id = (id) => document.getElementById(id);
  const hasSwal = typeof window.Swal?.fire === 'function';

  // Ajusta si tus endpoints son distintos
const API_LOOKUP = "https://merrell.engranedigital.com/facturacion/api/factura-consulta";
const API_SUBMIT = "https://merrell.engranedigital.com/facturacion/api/facturar"; // por si ya lo usas abajo

  const alertLoading = (msg = 'Estamos verificando la información') => {
    if (!hasSwal) return;
    Swal.fire({
      title: 'ESPERA',
      text: msg,
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,
      didOpen: () => Swal.showLoading(),
    });
  };
  const alertResult = (icon = 'info', msg = 'Listo') => {
    if (hasSwal) {
      return Swal.fire({
        icon,
        text: msg,
        confirmButtonText: 'Aceptar',
        allowOutsideClick: false,
        allowEscapeKey: false,
      });
    }
    alert(msg);
    return Promise.resolve();
  };
  const closeAlert = () => { if (hasSwal) Swal.close(); };

  const _debounce = (fn, wait = 180) => {
    let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), wait); };
  };
  const _t = (v) => (typeof v === 'string' ? v.trim() : v);

  /* ---------- Mostrar/ocultar secciones con (des)habilitado seguro ---------- */
  const openSection = (el, asFlex = false) => {
    if (!el) return;
    el.classList.add('is-open');
    el.style.display = asFlex ? 'flex' : 'block';
    el.querySelectorAll('input, select, textarea, button').forEach(i => i.disabled = false);
  };
  const closeSection = (el) => {
    if (!el) return;
    el.classList.remove('is-open');
    el.style.display = 'none';
    el.querySelectorAll('input, select, textarea, button').forEach(i => {
      if (i.type !== 'hidden') i.disabled = true;
    });
  };

  /* ---------- (Des)habilitar el resto del formulario ---------- */
  const disableRestOfForm = (form, exceptIds = []) => {
    const whitelist = new Set(exceptIds);
    Array.from(form.elements).forEach(el => {
      if (!el || el.type === 'hidden') return;
      if (el.id && whitelist.has(el.id)) return;
      if (el.closest('#lookup-controls')) return; // bloque de consulta siempre habilitado si existe
      el.disabled = true;
    });
  };
  const enableRestOfForm = (form) => {
    Array.from(form.elements).forEach(el => {
      if (!el || el.type === 'hidden') return;
      el.disabled = false;
    });
  };

  /* ---------- Validación de RFC ---------- */
  const validateRfcLocal = (value) => {
    const rfc = String(value || '').toUpperCase();
    const fisica = /^[A-ZÑ&]{4}\d{6}[A-Z0-9]{3}$/; // 13
    const moral  = /^[A-ZÑ&]{3}\d{6}[A-Z0-9]{3}$/; // 12
    let type = null, isValid = false;

    if (fisica.test(rfc)) { type = 'person';  isValid = true; }
    else if (moral.test(rfc)) { type = 'company'; isValid = true; }

    if (isValid) {
      const pos = type === 'person' ? 4 : 3;
      const y = +rfc.slice(pos, pos+2), m = +rfc.slice(pos+2, pos+4), d = +rfc.slice(pos+4, pos+6);
      if (!(m >= 1 && m <= 12 && d >= 1 && d <= 31)) isValid = false;
    }
    return { isValid, type };
  };
  const validateRfcAdapter = (value) => {
    if (typeof window.validateRfc === 'function') {
      try { return window.validateRfc(value, true); } catch (_) {}
    }
    return validateRfcLocal(value);
  };

  /* ---------- App ---------- */
  document.addEventListener('DOMContentLoaded', () => {
    const form            = $id('facturar-form');
    if (!form) return;

    // Campos existentes del formulario
    const correoForm      = $id('correo');
    const rfcInput        = $id('rfc');
    const uso_cfdi        = $id('uso_cfdi');
    const cfdi            = $id('cfdi');
    const empresaInput    = $id('empresa');
    const nombre          = $id('nombre');
    const apellidoPaterno = $id('apellido_paterno');
    const apellidoMaterno = $id('apellido_materno');
    const codigoPostal    = $id('codigo_postal');
    const telefono        = $id('telefono');
    const calle           = $id('calle');
    const numIntExt       = $id('numero_int_ext');
    const colonia         = $id('colonia');
    const ciudad          = $id('ciudad');
    const estado          = $id('estado');
    const msgRfcOk        = $id('msg_rfc');
    const msgRfcErr       = $id('msg_rfc_val');
    const clienteBox      = $id('datos-cliente');
    const empresaBox      = $id('datos-empresa');
    const btnSubmit       = form.querySelector('button[type="submit"], .form_submit_div .btn');

    // Campos de consulta (primera fila/paso 1)
    const pedidoLookup    = $id('pedido_lookup');
    const correoLookup    = $id('correo_lookup');
    const btnConsulta     = $id('btn-consulta');

    // Oculta secciones RFC por defecto
    closeSection(clienteBox);
    closeSection(empresaBox);
    if (msgRfcOk)  msgRfcOk.style.display  = 'none';
    if (msgRfcErr) msgRfcErr.style.display = 'none';

    // Bloquea todo menos la línea de consulta
    disableRestOfForm(form, ['pedido_lookup', 'correo_lookup', 'btn-consulta']);

    // Normalización de entradas
    codigoPostal?.addEventListener('input', () => {
      codigoPostal.value = codigoPostal.value.replace(/\D/g, '').slice(0,5);
    });
    telefono?.addEventListener('input', () => {
      telefono.value = telefono.value.replace(/[^\d+()\-\s]/g, '').slice(0,20);
    });

    // RFC: mostrar secciones según tipo y requeridos dinámicos
    function handleRfcValidation() {
      if (!rfcInput) return;
      rfcInput.value = rfcInput.value.toUpperCase();

      const RFC  = validateRfcAdapter(rfcInput.value);
      const isOk = RFC?.isValid === true;
      const type = RFC?.type;

      if (msgRfcOk)  msgRfcOk.style.display  = isOk ? 'inline' : 'none';
      if (msgRfcErr) msgRfcErr.style.display = isOk ? 'none'   : 'inline';

      if (isOk && type === 'person') {
        openSection(clienteBox, /*asFlex*/ true);
        closeSection(empresaBox);

        if (nombre)           nombre.required = true;
        if (apellidoPaterno)  apellidoPaterno.required = true;
        if (apellidoMaterno)  apellidoMaterno.required = true;
        if (empresaInput)     empresaInput.required = false;

      } else if (isOk && type === 'company') {
        closeSection(clienteBox);
        openSection(empresaBox);

        if (empresaInput)     empresaInput.required = true;
        if (nombre)           nombre.required = false;
        if (apellidoPaterno)  apellidoPaterno.required = false;
        if (apellidoMaterno)  apellidoMaterno.required = false;

      } else {
        closeSection(clienteBox);
        closeSection(empresaBox);

        if (empresaInput)     empresaInput.required = false;
        if (nombre)           nombre.required = false;
        if (apellidoPaterno)  apellidoPaterno.required = false;
        if (apellidoMaterno)  apellidoMaterno.required = false;
      }
    }

    // Compatibilidad con onkeyup="validarRFC()" en HTML
    window.validarRFC = _debounce(handleRfcValidation, 180);
    rfcInput?.addEventListener('input', window.validarRFC);
    rfcInput?.addEventListener('paste', () => setTimeout(window.validarRFC, 0));
    rfcInput?.addEventListener('blur', handleRfcValidation);
    if (rfcInput?.value) handleRfcValidation(); // valida si viene prellenado

    // CONSULTA: habilitar el formulario si la API confirma
    btnConsulta?.addEventListener('click', async (e) => {
      e.preventDefault();

      const pedido = _t(pedidoLookup?.value);
      const email  = _t(correoLookup?.value);

      if (!pedido) { await alertResult('error', 'Ingresa el número de pedido.'); return; }
      if (!email)  { await alertResult('error', 'Ingresa el correo del pedido.'); return; }

      alertLoading('Estamos verificando tu información…');

      const controller = new AbortController();
      const timeoutId  = setTimeout(() => controller.abort(), 15000);

      try {
        const res = await fetch(API_LOOKUP, {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({ order: pedido, email }),
          signal: controller.signal
        });

        clearTimeout(timeoutId);

        let json = {};
        try { json = await res.json(); } catch (_) {}
        closeAlert();

        // Admite { ok:true } o { status:'ok' }
        const okFlag   = json && (json.ok === true || String(json.status).toLowerCase() === 'ok');
        const failFlag = json && (json.ok === false || String(json.status).toLowerCase() === 'false');

        if (!res.ok || failFlag) {
          const msg = json?.message || 'La información ingresada es incorrecta, verifique su correo o número de pedido.';
          await alertResult('error', msg);
          return;
        }

        if (okFlag) {
          await alertResult('success', 'Datos verificados. Continúa con la facturación.');
          enableRestOfForm(form);

          // prellenar para consistencia visual
          if (pedidoLookup) pedidoLookup.value = pedido;
          if (correoLookup && !correoLookup.value) correoLookup.value = email;

          // foco al RFC para continuar
          rfcInput?.focus();
          return;
        }

        await alertResult('error', 'No pudimos validar la información. Intenta nuevamente.');
      } catch (err) {
        closeAlert();
        const timedOut = err?.name === 'AbortError';
        await alertResult('error', timedOut
          ? 'Sin respuesta del servidor. Inténtalo otra vez.'
          : (err?.message || 'Ocurrió un error inesperado.')
        );
      }
    });

    // SUBMIT: validaciones y envío a API_SUBMIT
    async function onSubmit(e) {
      e.preventDefault();

      // Validaciones mínimas
      const rfcCheck = validateRfcAdapter(rfcInput?.value);
      if (!rfcInput?.value || !rfcCheck.isValid) {
        await alertResult('error', 'El RFC no es válido.');
        return;
      }
      if (!cfdi?.value)     { await alertResult('error', 'Selecciona tu régimen fiscal (CFDI).'); return; }
      if (!uso_cfdi?.value) { await alertResult('error', 'Selecciona el USO CFDI.'); return; }
      if (!correoForm?.value){ await alertResult('error', 'El correo es obligatorio.'); return; }
      if (!codigoPostal?.value || codigoPostal.value.replace(/\D/g, '').length !== 5) {
        await alertResult('error', 'El Código Postal debe tener 5 dígitos.'); return;
      }

      const payload = {
        order:            _t(pedidoLookup?.value),
        email:            _t(correoLookup?.value),
        rfc:              _t(rfcInput?.value?.toUpperCase()),
        cfdi:             _t(cfdi?.value),
        uso_cfdi:         _t(uso_cfdi?.value),
        empresa:          _t(empresaInput?.value),
        nombre:           _t(nombre?.value),
        apellido_paterno: _t(apellidoPaterno?.value),
        apellido_materno: _t(apellidoMaterno?.value),
        codigo_postal:    _t(codigoPostal?.value),
        telefono:         _t(telefono?.value),
        calle:            _t(calle?.value),
        numero_int_ext:   _t(numIntExt?.value),
        colonia:          _t(colonia?.value),
        ciudad:           _t(ciudad?.value),
        estado:           _t(estado?.value),
      };

      // Evita doble submit
      if (btnSubmit) btnSubmit.disabled = true;

      alertLoading('Estamos validando tus datos…');

      const controller = new AbortController();
      const timeoutId  = setTimeout(() => controller.abort(), 15000);

      try {
        const res = await fetch(API_SUBMIT, {
          method: 'POST',
          mode: 'cors',
          credentials: 'omit',
          cache: 'no-store',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            'X-Request-Id': (crypto?.randomUUID && crypto.randomUUID()) || String(Date.now()),
          },
          body: JSON.stringify(payload),
          signal: controller.signal,
        });

        clearTimeout(timeoutId);

        if (!res.ok) {
          const txt = await res.text().catch(() => '');
          throw new Error(txt || `Error HTTP ${res.status}`);
        }

        const json = await res.json().catch(() => { throw new Error('La respuesta no es un JSON válido.'); });

        closeAlert();
        await alertResult(json?.icon || 'success', json?.msg || 'Operación realizada correctamente.');
        location.reload();

      } catch (err) {
        closeAlert();
        const timedOut = err?.name === 'AbortError';
        await alertResult('error', timedOut
          ? 'No hay respuesta del servidor. Inténtalo nuevamente.'
          : (err?.message || 'Ocurrió un error inesperado.')
        );
      } finally {
        if (btnSubmit) btnSubmit.disabled = false;
      }
    }

    form.addEventListener('submit', onSubmit);
  });
})();